import BaseModelTransfer from "@/models/BaseModelTransfer.js";

export const GridConfig = {
	list: BaseModelTransfer.list,
	columns: BaseModelTransfer.columns,
	query: {
		batchQuery: true,
		filter: function (o) {
			return o.BusinessEvent == 'Transfer' && (o.WorkflowStatus == 'Approved' || o.WorkflowStatus == 'Correction Pending' || o.WorkflowStatus == 'Correction Approved')
		},
		limit: 5000
	},
	grid: {
		gridId: "TransferReportGrid",
		height: 500,
		checkbox: true,
		groupable: true,
		erase: false,
		document: true,
		actionsColumnWidth:60
	},
}

export const ToolBarConfig = {
	items: [{
			template: '<Label>From :</Label><input id="TransferReportFromDate" />',
			overflow: "never"
		},
		{
			template: '<Label>To :</Label><input id="TransferReportToDate" />',
			overflow: "never"
		},
		// {
		// 	template: '<div id="daterangepicker"></div>',
		// 	overflow: "never"
		// },
		{
			id: "btnBulkAttachment",
			type: "button",
			text: "Attach Documents",
			showIcon: "toolbar",
			icon: "attachment",
			attributes: {
				"class": "float-right-btn btn btn-primary"
			}
		}
	]
}